$(function() {
  const anchorLinkEls = document.querySelectorAll('.anchor-link');
  if (anchorLinkEls) {
    anchorLinkEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const sectionName = el.getAttribute('href').replace('#', '');
        location.hash = sectionName;
        const sectionEl = document.getElementById(sectionName);
        sectionEl.scrollIntoView();
      });
    });
  }
})
